import React from 'react';
import Line, { Color } from 'components/general/wizard/Line';

interface Props {
  currentStep: number;
  totalSteps: number;
}

const Wizard = (wizard: Props) => {
  const styles = require('./Wizard.module.scss');
  const lines = Array.from({ length: wizard.totalSteps }, (_, index) =>
    index < wizard.currentStep ? Color.White : Color.BlueLight
  );

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        {lines.map((color, idx) => (
          <Line
            key={idx}
            color={color}
            className={styles.line}
          />
        ))}
      </div>
      <p className={styles.stepText}>
        Step {wizard.currentStep}/{wizard.totalSteps}
      </p>
    </div>
  );
};

export default Wizard;
